"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = () => ({
  '@global': {
    '.emoji-mart': {
      border: 'none'
    }
  }
});
exports.default = _default;